module.exports = __webpack_public_path__ + "img/photo-0135.bba8b770.jpg";